import { Component, OnInit, Output, EventEmitter, Input, } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

/**
 * Custom Decorator import.
 */
import { OnChange } from 'src/app/custom-decorators/ngOnchanges.Decorator';

@Component({
  selector: 'app-tag-user',
  templateUrl: './tag-user.component.html',
  styleUrls: ['./tag-user.component.scss']
})

export class TagUserComponent implements OnInit {

  /**
   * to emit on focus event on tag search list
   */

  @Output() onfocusTag : EventEmitter<void> = new EventEmitter();

  @Output() removeUser: EventEmitter<any> = new EventEmitter();

  @Output() addUser: EventEmitter<any> = new EventEmitter();

  @Output() listReload: EventEmitter<{offset: number, keyword: string}> = new EventEmitter();

  @Output() emithidden: EventEmitter<boolean> = new EventEmitter();
  @Output() emitOnClear: EventEmitter<any> = new EventEmitter();

  /**
   * to input user list
   */
  @OnChange<boolean>('updateView')
  @Input() userList;

  @Input() noResultText;

  @Input() headingText;

  @Input() activeStoryIndex;
  @Input() showUserList;

  @Input() currentPlaying = false;


  @Input() listOffset: number;

  @OnChange<boolean>('onSelectedListChanges')
  @Input() selectedList;

  public err_msg: string;

  @Input() errorMsg: string;


  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  public subject: Subject<string> = new Subject();



  /**
   * current offset
   */
  public currentOffset = 1;
  public searchKeyValue = '';

  /**
   * max tagging
   */
  public maxLength = 5;
  constructor(
    private cd: ChangeDetectorRef
  ) { }

  /**
   * to load start data;
   */
  emitOnFocus(): void {
    this.err_msg = '';
    if (!this.showUserList) {
      this.onfocusTag.emit();
    }
  }
  updateView(): void {
    this.cd.markForCheck();
    this.cd.detectChanges();
  }
  onSelectedListChanges(): void {
    this.cd.markForCheck();
    this.cd.detectChanges();
  }
  /**
   * function to close view
   */
  closeView(): void {
    this.err_msg = '';
    this.cd.markForCheck();
    this.emithidden.emit(false);
  }
  /**
   * clear search
   */
  clearSearch(): void {
    if (document.querySelector<HTMLInputElement>('#userSearch')) {
      document.querySelector<HTMLInputElement>('#userSearch').value = '';
      this.searchKeyValue = '';
    }
    this.searchKeyValue = '';
    this.emitOnClear.emit();
  }

  /**
   * function to search user
   * @param event
   */
  userSearch(value): void {
   const val =   document.querySelector<HTMLInputElement>('#userSearch').value;
   this.searchKeyValue = val;
   this.listReload.emit({offset: 1, keyword: val});
  }
  /**
   * function to uncheck check
   *
   */
  isSelected(conn): boolean {
    let isSelected = false;
    for (let i = 0; i < this.selectedList.length; i++) {
      if (this.selectedList[i]?.uuid === conn) {
        isSelected = true;
        break;
      }
    }
    return isSelected;
  }


  /**
   * scrolling the tag list
   */
  onScroll(): void {
    const val =  document.querySelector<HTMLInputElement>('#userSearch').value;
    this.searchKeyValue = val;
    if (this.listOffset > 0) {
      this.listReload.emit({offset: this.listOffset, keyword: val });
    } 
  }
  /**
   * function to handle click events on checkboxes;
   */
  addOrRemoveTag(event, user): boolean {
    this.err_msg = '';
    if (event.target.checked) {
      if (this.selectedList.length === this.maxLength) {
        event.target.checked = false;
        this.err_msg = this.errorMsg;
        return false;
      }
      this.addUser.emit(user);
    }
    else {
      this.removeUser.emit(user);
    }
    this.cd.markForCheck();
    return true;
  }
  ngOnInit(): void {
    this.userSearch('');
    this.searchKeyValue = '';
    this.subscriptions.add(this.subject.pipe(
      debounceTime(300)
    ).subscribe(x => {
      this.userSearch(x);
    }));
  }



}

